import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import { Link, useNavigate } from "react-router-dom";
import logo from "./assets/images/logo.svg";
import logoCmetric from "./assets/images/logo-cmetric.png";

function Nav({ setToken }) {
  const navigate = useNavigate();
  const isLoggedIn = sessionStorage.getItem("token") === "loggedIn";

  const handleLogout = () => {
    sessionStorage.removeItem("token");
    setToken(null);
    navigate("/login"); // Redirect to login page
  };

  return (
    <div>
      {/* Navbar */}
      <nav className="navbar navbar-expand-lg shadow-sm py-3">
        <div className="container">
          <Link className="navbar-brand fw-bold" to="/">
            <img src={logo} alt="Logo" className="logo" />
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav mx-auto">
              <li className="nav-item">
                <Link className="nav-link" to="/">
                  Home
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/invoice">
                  Invoice AI
                </Link>
              </li>
              {!isLoggedIn ? (
                <>
                  <li className="nav-item">
                    <Link className="nav-link" to="/login">
                      Login
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link className="nav-link" to="/register">
                      Register
                    </Link>
                  </li>
                </>
              ) : (
                <>
                  <li className="nav-item">
                    <button
                      className="nav-link text-danger"
                      onClick={handleLogout}
                    >
                      Logout
                    </button>
                  </li>
                </>
              )}
            </ul>
            <Link
              className="navbar-brand fw-bold"
              to="https://www.c-metric.com/"
            >
              <img src={logoCmetric} alt="Logo" className="logo_cmetric" />
            </Link>
          </div>
        </div>
      </nav>
      {/* <Home /> */}
    </div>
  );
}

export default Nav;
